import { FormControl, MenuItem, Select } from '@material-ui/core';
import { icon_login_account, icon_login_admin, img_logo_L } from 'components/base/images';
import MuiButton from 'components/common/button/MuiButton';
import MuiWrapper from 'components/common/input/MuiWrapper';
import CustomText from 'components/common/text/CustomText';
import T from 'components/common/text/T';
import LegalAgreement from 'components/legal/LegalAgreement';
import { logoMapper } from 'lib/clinic/mapper';
import { pageUrl } from 'lib/mapper';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { BaseActions, UtilActions } from 'store/actionCreators';
import { useShallowAppSelector } from 'store/hooks';
import { connectDofAuth } from 'store/modules/auth';
import styled from 'styled-components';
import { oemState } from 'lib/store';

interface CodeRegistrationProps {
  isAgreementModal: boolean;
  willSelectLeagal: boolean;
  isUserType: boolean;
  signInEmail: {
    value: string;
    onChange: (e: any) => void;
    setValue: (value: string) => void;
  };
  onSubmitUpdateUserType: (userType: Number) => void;
  onSubmitLegal: (legalArr: any[], userType: Number) => void;
  onCancelLegal: () => void;
  onCheckUpdateVersion: () => void;
}

function CodeRegistration({
  willSelectLeagal,
  isUserType,
  isAgreementModal,
  signInEmail,
  onSubmitUpdateUserType,
  onSubmitLegal,
  onCancelLegal,
  onCheckUpdateVersion,
}: CodeRegistrationProps) {
  const {
    language,
    dim,
    loginAdminHistory,
    supportLanguageList: { list: languageList },
  }: {
    language: string;
    dim: boolean;
    loginAdminHistory: string;
    supportLanguageList: { list: any };
  } = useShallowAppSelector(state => ({
    language: state.base.language,
    dim: state.app.dim,
    loginAdminHistory: state.auth.loginAdminHistory,
    supportLanguageList: state.util.supportLanguageList.data || {},
  }));

  const { t } = useTranslation();
  const { ipcRenderer } = window;
  const history = useHistory();
  const [browserDim, setBrowserDim] = useState(false);
  const [lang, setLang] = useState<string>(language);
  const handleChangeLanguage = (e: any) => {
    setLang(e.target.value);
    BaseActions.change_language(e.target.value);
  };

  const windowClose = () => {
    window.open('', '_self', '');
    return false;
  };

  useEffect(() => {
    getLanguage();
  }, []);

  const getLanguage = async () => {
    if (!!ipcRenderer) {
      const resData = await ipcRenderer.invoke('getLanguage');
      setLang(resData.language);
      BaseActions.change_language(resData.language);
    }
  };

  useEffect(() => {
    UtilActions.fetch_support_language_list_request();
  }, []);

  return (
    <StyledCodeRegistraion data-component-name="CodeRegistraion" dim={dim} browserDim={browserDim}>
      {!!isAgreementModal ? (
        <LegalAgreement
          willSelectLeagal={willSelectLeagal}
          isUserType={isUserType}
          onSubmitUpdateUserType={onSubmitUpdateUserType}
          onSubmitLegal={onSubmitLegal}
          onCancelLegal={onCancelLegal}
        />
      ) : (
        <div className={`codeRegistration__wrapper ${oemState()}`}>
          <div className="dim">
            <T>DONT_REFRESH</T>
          </div>
          <div className="browserDim">
            <MuiButton onClick={windowClose}>close</MuiButton>
          </div>

          <div className="codeRegistration__language_content">
            <div className="codeRegistration__language_box">
              <div className="codeRegistration__language_label">
                <T>GLOBAL_LANGUAGE</T>
              </div>
              <div className="codeRegistration__language">
                <MuiWrapper className="codeRegistration__language_select_wrapper sm">
                  <FormControl fullWidth variant="outlined">
                    <Select
                      MenuProps={{
                        anchorOrigin: {
                          vertical: 'bottom',
                          horizontal: 'left',
                        },

                        getContentAnchorEl: null,
                      }}
                      name="currency"
                      value={lang}
                      onChange={e => {
                        handleChangeLanguage(e);
                      }}
                    >
                      {languageList?.map(
                        (item: any, index: number) => {
                          return (
                            <MenuItem value={item.language.toLowerCase()} key={index}>
                              {item.languageAlias}
                            </MenuItem>
                          );
                        },
                        [lang],
                      )}
                    </Select>
                  </FormControl>
                </MuiWrapper>
              </div>
            </div>
          </div>
          <div className="codeRegistration__main_content">
            <div className="codeRegistration__main_title">
              <div className="codeRegistration__logo_box">
                <img
                  src={logoMapper[`${oemState()}_large`]}
                  alt="dof"
                  className="codeRegistration__logo"
                />
              </div>
              <div className="codeRegistration__title_box">
                <CustomText fontSize={32} fontWeight={300}>
                  <T>LOGIN_TYPE_SELECT</T>
                </CustomText>
              </div>
            </div>
            <div className="codeRegistration__main_button">
              <div className="codeRegistration__button_box">
                <button
                  className="button_top"
                  onClick={() => {
                    onCheckUpdateVersion();
                    signInEmail.setValue(loginAdminHistory);
                    connectDofAuth('signIn');
                  }}
                >
                  <img src={icon_login_admin} alt="dof" className="codeRegistration__button_logo" />
                  <CustomText fontSize={26} fontWeight={400} fontColor="#1b2960">
                    <T>LOGIN_TYPE_MANAGER</T>
                  </CustomText>
                </button>
                <div className="button_bottom">
                  <CustomText fontSize={16} fontWeight={400} fontColor="#444444">
                    <T>LOGIN_MANAGER_CONTENT_1</T>
                  </CustomText>
                  <button
                    className="codeRegistration__btn btn-reset sign-in"
                    onClick={() => {
                      onCheckUpdateVersion();
                      connectDofAuth('signUp');
                    }}
                  >
                    <CustomText
                      fontSize={16}
                      fontWeight={400}
                      fontColor="#00a6e2"
                      style={{
                        textDecoration: 'underline',
                      }}
                    >
                      <T>LOGIN_MANAGER_CONTENT_2</T>
                    </CustomText>
                  </button>
                </div>
              </div>
              <div className="codeRegistration__button_box">
                <button
                  className="button_top"
                  onClick={() => {
                    onCheckUpdateVersion();
                    history.push({ pathname: pageUrl.auth.signIn });
                  }}
                >
                  <img
                    src={icon_login_account}
                    alt="dof"
                    className="codeRegistration__button_logo"
                  />
                  <CustomText fontSize={26} fontWeight={400} fontColor="#1b2960">
                    <T>LOGIN_TYPE_EMPLOYEE</T>
                  </CustomText>
                </button>
                <div className="button_bottom">
                  <CustomText fontSize={16} fontWeight={400} fontColor="#444444">
                    <T>LOGIN_EMPLOYEE_CONTENT</T>
                  </CustomText>
                  {/* <CustomText fontSize={16} fontWeight={400} fontColor="#444444">
                    <T>LOGIN_EMPLOYEE_CONTENT_2</T>
                  </CustomText> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </StyledCodeRegistraion>
  );
}

export default React.memo(CodeRegistration);

const StyledCodeRegistraion = styled.section<{ dim: boolean; browserDim: boolean }>`
  display: block;

  #root {
    background-color: #f7f9fa !important;
  }

  .dim {
    display: ${({ dim }) => (dim ? 'flex' : 'none')};
    z-index: 10001;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    align-items: center;
    justify-content: center;
    font-size: 45px;
    letter-spacing: 0.5px;
  }

  .browserDim {
    display: ${({ browserDim }) => (browserDim ? 'flex' : 'none')};
    z-index: 10002;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    align-items: center;
    justify-content: center;
    font-size: 45px;
    letter-spacing: 0.5px;
  }

  .codeRegistration__wrapper {
    display: flex;
    flex-direction: column;
    position: absolute;
    width: 100%;
    height: 100%;
    min-width: 1904px;
    min-height: 925px;
    overflow: overlay;
    justify-content: center;
    align-items: center;
    .codeRegistration__language_content {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      justify-content: flex-end;
      width: 100%;
      .codeRegistration__language_box {
        display: flex;
        column-gap: 30px;
        margin: 40px 40px 0 0;
        align-items: center;
        .codeRegistration__language_label {
          font-size: 14px;
          font-weight: 500;
        }
        .codeRegistration__language {
          width: 200px;
        }
      }
    }
    .codeRegistration__main_content {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .codeRegistration__main_title {
        margin: 0 0 50px 0;
        .codeRegistration__logo_box {
          margin: 0 0 20px 0;
          display: flex;
          justify-content: center;
        }
        .codeRegistration__title_box {
          display: flex;
          justify-content: center;
        }
      }
      .codeRegistration__main_button {
        display: flex;
        column-gap: 30px;
        flex-direction: row;
        .codeRegistration__button_box {
          width: 310px;
          height: 500px;
          border-radius: 5px;
          border: solid 1px #d1d1d1;
          background-color: #ffffff;
          overflow: hidden;
          &:hover {
            box-shadow: 0 3px 20px 0 rgb(0 0 0 / 16%);
          }
          .button_top {
            flex-direction: column;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 340px;
            width: 100%;
            background-color: #fbfbfb;
            border-bottom: solid 1px #d1d1d1;
            row-gap: 30px;
          }
          .button_bottom {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            row-gap: 10px;
            height: 160px;
            padding: 20px;
            text-align: center;
          }
        }
      }
    }
  }
`;
